import { Menu, MenuList } from '@lokalise/louis';

import type { NavigationItem } from '../../../../types/navigation';
import NavigationBlockItem from '../NavigationBlockItem';
import DropdownContent from './DropdownContent';
import { NavigationItemList, NavigationItemWrapper } from './styles';

interface NavigationBlockProps {
    collapsed: boolean;
    navigation: NavigationItem[];
}

const NavigationBlock = ({ collapsed, navigation }: NavigationBlockProps) => (
    <nav aria-label="Quick links">
        <NavigationItemList aria-orientation="horizontal">
            {navigation
                .filter((item) => item.visible)
                .map((item) => {
                    if (item.dropdown) {
                        return (
                            <NavigationItemWrapper key={item.key}>
                                <Menu
                                    menuButton={({ opened }) => (
                                        <NavigationBlockItem
                                            icon={item.icon}
                                            label={item.label}
                                            disabled={item.disabled}
                                            small={collapsed}
                                            active={opened}
                                        />
                                    )}
                                >
                                    <MenuList>
                                        <DropdownContent items={item.dropdown} />
                                    </MenuList>
                                </Menu>
                            </NavigationItemWrapper>
                        );
                    }

                    return (
                        <NavigationItemWrapper key={item.key}>
                            <NavigationBlockItem
                                icon={item.icon}
                                label={item.label}
                                href={item.link}
                                onClick={item.onClick}
                                disabled={item.disabled}
                                badge={item.badge}
                                small={collapsed}
                            />
                        </NavigationItemWrapper>
                    );
                })}
        </NavigationItemList>
    </nav>
);

export default NavigationBlock;
